import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly DATADOG_CLIENT_TOKEN = 'pubd38088732d836d7af1b45fe3c03c7afa';
   DATA_DOG_VERSION = '25386140309';
  DATA_DOG_ENV = '';
  DATA_DOG_TOKEN = '';

  constructor() {
    this.setDatadogConfiguration();
  }

  get config() {
    const hostname = window.location.hostname.toLowerCase();
    const subdomain = hostname.split('.')[0];

    let environment;
    let apiBaseUrl;
    if (subdomain === 'localhost') {
      environment = 'LOCAL';
      // * So localhost can use sampletree/treesample for testing
      apiBaseUrl = 'https://accounting-api-qa.golmn.com/';
    } else if (window.location.host.match(/dev/)) {
      environment = 'DEV';
      apiBaseUrl = 'https://accounting-api-dev.golmn.com/';
    } else if (window.location.host.match(/qa/)) {
      environment = 'QA';
      apiBaseUrl = 'https://accounting-api-qa.golmn.com/';
    } else if (window.location.host.match(/rt/)) {
      environment = 'RT';
      apiBaseUrl = 'https://accounting-api-rt.golmn.com/';
    } else {
      environment = 'PROD';
      apiBaseUrl = 'https://accounting-api.golmn.com/';
    }

    const isGG = /groundsguyspro/i.test(hostname);

    return {
      environment: environment,
      isGG: isGG,
      apiBaseUrl: apiBaseUrl,
    };
  }

  get LAUNCH_DARKLY_CLIENT_ID() {
    if (
      location.host.match(/local/) ||
      location.host.match(/dev/) ||
      location.host.match(/dev2/)
    ) {
      return '676195b671eaf00b75c69e88';
    } else if (location.host.match(/qa/)) {
      return '676195a7b6863b0974448b83';
    } else if (location.host.match(/rt/)) {
      return '67619589a6712f0952f469fe';
    } else if (
      location.host.match(/my/) ||
      location.host.match(/groundsguyspro/)
    ) {
      return '67619555ff094e0b7a0767b9';
    }
    return '676195b671eaf00b75c69e88';
  }

  /**
   * HostType is needed as a separate instance
   * Need to define it on init of the service
   */
  private setDatadogConfiguration(): void {
    const hostname = window.location.hostname.toLowerCase();
    const subdomain = hostname.split('.')[0];

    if (subdomain === 'localhost') {
      this.DATA_DOG_ENV = 'local';
    } else if (window.location.host.match(/dev/)) {
      this.DATA_DOG_ENV = 'dev';
    } else if (window.location.host.match(/qa/)) {
      this.DATA_DOG_ENV = 'qa';
      this.DATA_DOG_TOKEN = this.DATADOG_CLIENT_TOKEN;
    } else if (window.location.host.match(/rt/)) {
      this.DATA_DOG_ENV = 'rt';
      this.DATA_DOG_TOKEN = this.DATADOG_CLIENT_TOKEN;
    } else {
      this.DATA_DOG_ENV = 'production';
      this.DATA_DOG_TOKEN = this.DATADOG_CLIENT_TOKEN;
    }
  }
}
